<template>
  <BaseSimpleDropdown
    ref="LanguageSelector"
    v-if="selectedLanguage"
    :position="'bottom-left'"
    :offsetTop="40"
    :options="languagesList"
    :clearable="false"
    :button-text="selectedLanguage ? selectedLanguage.title : ''"
    :selected-option="currentLang ? currentLang : ''"
    @selectOption="changeLang($event)"
    @toggleDropdown="$emit('toggleDropdown', $event)"
  >
    <template #optionButton>
    <slot></slot>
    </template>
  </BaseSimpleDropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import { USER_SAVE } from '@/store/actions/user';
import BaseSimpleDropdown from '@/views/RenovaDashboard/components/ui-kit/Dropdowns/BaseSimpleDropdown';
import { GET_DICTIONARY } from '@/store/actions/dictionary';

export default {
  name: 'LangSwitcher',
  components: {
    BaseSimpleDropdown,
  },
  props: {
    reloadApp: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentLang: null,
    };
  },
  computed: {
    ...mapGetters(['user', 'languages', 'defaultLocale']),
    languagesList() {
      return [...this.languages];
    },
    selectedLanguage() {
      return this.languagesList?.find((lang) => lang.id === this.currentLang || lang.id === this.defaultLocale);
    },
  },
  created() {
    this.currentLang = localStorage.getItem('lang') || this.defaultLocale;
  },
  methods: {
    changeLang(lang) {
      this.currentLang = lang;
      localStorage.setItem('lang', lang);
      this.$store
        .dispatch(USER_SAVE, {
          id: this.user.id,
          defaultLocale: lang,
        })
        .then(() => {
          Promise.all([
            this.$store.dispatch(GET_DICTIONARY),
            this.$store.dispatch('saveUserSettings', {
              defaultLanguage: lang,
              notification: {
                leadCreated: {
                  browser: false,
                  email: false,
                },
              },
            }),
          ]).then(() => {
            if (this.reloadApp) {
              window.location.reload();
            }
          });
        });
    },
  },
};
</script>
